module.exports = __webpack_public_path__ + "img/title9.9a023f31.png";